<template>
    <b-card
        :bg-variant="bgColor"
        :body-bg-variant="bodyBgColor"
        :header="header"
        :no-body="noBody"
        :title="title"
        @click="$emit('click')"
    >
        <slot />
    </b-card>
</template>

<script>
// Components.
import {BCard} from 'bootstrap-vue'

export default {
    components: {BCard},
    props: {
        bgColor: {type: String},
        bodyBgColor: {type: String},
        header: {type: String},
        noBody: {type: Boolean},
        title: {type: String},
    },
}
</script>